module.exports = __webpack_public_path__ + "zespol_06.jpg?f936c80ca95b3071b35cc1d834cf248e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zespol_06.jpg
// module id = 151
// module chunks = 0